import { useTranslation } from "react-i18next";
import { Building2 } from "lucide-react";
import { useRef, useEffect } from "react";

const customers = [
  { name: "Voltras", image: "/voltras.png" },
  { name: "PP", image: "/PP.png" },
  { name: "Solusindo", image: "/solusindo.png" },
  { name: "Sandton", image: "/SANDTON.png" },
  { name: "PT. IP TRIBE", image: "/PT.IP TRIBE.png" },
  { name: "RAD", image: "/RAD.png" },
  { name: "Adhikarya", image: "/ADHIKARYA.jpg" },
  { name: "Aktuator", image: "/aktuator.png" },
  { name: "Portal Properti Indonesia", image: "/PT. Portal Properti Indonesia.png" },
  { name: "Altimeda", image: "/Altimeda.png" },
  { name: "Indo Berlian Cemerlang", image: "/PT. INDO BERLIAN CEMERLANG.jpg" },
  { name: "Nadara Digital", image: "/NADARA DIGITAL.png" },
];

export default function CustomersSection() {
  const { t } = useTranslation();
  const trackRef = useRef(null);
  const sliderRef = useRef(null);

  useEffect(() => {
    const track = trackRef.current;
    const slider = sliderRef.current;

    if (!track || !slider) return;

    // Clone each logo to create infinite scroll effect
    const logos = Array.from(track.children);
    logos.forEach((logo) => {
      const clone = logo.cloneNode(true);
      track.appendChild(clone);
    });

    // Pause animation on hover
    const handleMouseOver = () => {
      track.style.animationPlayState = "paused";
    };

    const handleMouseOut = () => {
      track.style.animationPlayState = "running";
    };

    slider.addEventListener("mouseover", handleMouseOver);
    slider.addEventListener("mouseout", handleMouseOut);

    return () => {
      slider.removeEventListener("mouseover", handleMouseOver);
      slider.removeEventListener("mouseout", handleMouseOut);
    };
  }, []);

  return (
    <section className="py-16 sm:py-12 px-6 md:px-16 sm:px-4 bg-white border-t-4 border-b-4 border-gray-100">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12 sm:mb-8">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-12 h-12 sm:w-10 sm:h-10 bg-blueLight rounded-full flex items-center justify-center">
              <Building2 className="w-6 h-6 sm:w-5 sm:h-5 text-textBlue" />
            </div>
            <span className="inline-block bg-gradient-to-r from-textBlue to-textBlueDark text-white text-sm sm:text-xs px-5 sm:px-3 py-2 sm:py-1.5 rounded-full">
              {t("customers.label")}
            </span>
          </div>
          <h2 className="text-4xl md:text-3xl sm:text-2xl font-bold text-gray-900 mb-4 sm:mb-3">
            {t("customers.title")}
          </h2>
          <p className="text-lg md:text-base text-gray-600 max-w-2xl mx-auto">
            {t("customers.description")}
          </p>
        </div>

        {/* Infinite Scroll Carousel */}
        <div className="customer-slider border-t border-b border-gray-200 py-8" ref={sliderRef}>
          {/* Fade edges for smooth effect */}
          <div className="absolute inset-y-0 left-0 w-20 sm:w-12 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none"></div>
          <div className="absolute inset-y-0 right-0 w-20 sm:w-12 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none"></div>

          {/* Logo Track */}
          <div className="customer-track" ref={trackRef}>
            {customers.map((customer) => (
              <img
                key={customer.name}
                src={customer.image}
                alt={customer.name}
                className="h-20 md:h-16 sm:h-12"
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
